export default function delay(ms) {
  return new Promise(res => {
    setTimeout(function() {
      return res();
    }, ms);
  });
}
